import React, { useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { getIn } from "formik";

export default ({ formik, fieldName }) => {
  // Helper function to get nested field value
  const getFieldValue = useCallback(() => {
    return getIn(formik.values, fieldName) || [];
  }, [formik.values, fieldName]);

  // Ensure options are initialized when component mounts
  useEffect(() => {
    const currentOptions = getFieldValue();
    if (currentOptions.length === 0) {
      formik.setFieldValue(fieldName, [
        { id: Date.now() + Math.random(), option: "" },
        { id: Date.now() + Math.random() + 1, option: "" }
      ]);
    }
  }, [fieldName, formik, getFieldValue]);

  const deleteOption = (ind) => {
    const currentOptions = getFieldValue();
    const newOptions = currentOptions.filter((_, index) => index !== ind);
    formik.setFieldValue(fieldName, newOptions);
  };

  const addOption = () => {
    const currentOptions = getFieldValue();
    const newOption = {
      id: Date.now() + Math.random(), // Generate unique ID
      option: "",
    };
    formik.setFieldValue(fieldName, [...currentOptions, newOption]);
  };

  const currentOptions = getFieldValue();

  // If no options, show a message
  if (currentOptions.length === 0) {
    return (
      <>
        <label className="poll-form-label">Fixed Response Options</label>
        <div className="text-muted">No options added yet. Click "Add another option" to get started.</div>
        <div className="form-group mt-2">
          <button
            type="button"
            className="btn btn-outline-warning poll-add-more-option-button full_w"
            onClick={addOption}
          >
            + Add another option
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <label className="poll-form-label">Fixed Response Options</label>
      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
        {currentOptions.map((item, index) => (
          <div key={item.id || index} className="d-flex align-items-center mb-2">
            <input
              type="text"
              className="form-control border-radius"
              placeholder={`Option ${index + 1}`}
              value={item.option || ""}
              onChange={(e) => {
                const newOptions = [...currentOptions];
                newOptions[index] = { ...newOptions[index], option: e.target.value };
                formik.setFieldValue(fieldName, newOptions);
              }}
              style={{ marginRight: "10px" }}
            />
            {index > 1 && (
              <FontAwesomeIcon
                onClick={() => deleteOption(index)}
                style={{ cursor: "pointer", color: "#dc3545", marginLeft: "10px" }}
                icon={faTrashAlt}
              />
            )}
          </div>
        ))}
      </div>
      
      <div className="form-group mt-2">
        <button
          type="button"
          className="btn btn-outline-warning poll-add-more-option-button full_w"
          disabled={currentOptions.length >= 10}
          onClick={addOption}
        >
          + Add another option
        </button>
      </div>
    </>
  );
};
